export const DEFAULT_DEGREE_COLLECTION_QUERY_INPUTS = {
  catalogAvailabilityStatus: ['LIVE'],
  productVariants: ['BachelorsDegree', 'MastersDegree', 'PostgraduateDiploma'],
};
